module.exports = __webpack_public_path__ + "static/media/Pink_Fish.6bfd4e0d.svg";